export const GALLERY_CONTENT_QUERY_API = 'https://gallery-content-query.cdn.vpsvc.com/api/v2'
export const GALLERY_CONTENT_API = 'https://gallery-content-api.cdn.vpsvc.com/api/v4'
export const DESIGN_TEMPLATE_SUPPORTED_MCID = 'businessCards'
export const DESIGN_TEMPLATE_SUPPORTED_MPVID = 'standardBusinessCards'
export const DESIGN_TEMPLATE_SUPPORTED_LOCALES = [
  'fr-FR',
  'de-DE',
  'en-GB',
  'en-US',
  'en-CA',
  'es-US',
  'fr-CA'
]

export const GALLERY_INDUSTRY_CATEGORY_KEY = 1
export const GALLERY_USE_CASE_CATEGORY_KEY = 1299

export const QUERY_PARAM_TAB = 'tab'
export const IMAGE_ALIGN = 'middle'
export const CLOUDINARY_TRANSFORM_TOKENS = 'c_fill,ar_4:5'
export const GALLERY_TEMPLATE_FETCH_TIMEOUT_MS = 1000
